import { createStyles, Theme } from "@material-ui/core";
export const TestDetailStyle = (theme: Theme) =>
  createStyles({
    whiteCard:{
        background: '#FFF',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        borderRadius: 4,
        padding: '16px 20px',
        marginBottom: 20,
        '& ::placeholder':{
            color: '#999',
            fontSize: 14,
        },
      },
      disabledSection: {
        opacity: 0.5,
        pointerEvents: "none",
      },
      lightQuestionCard:{
        background: '#FFF',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        borderRadius: 4,
        padding: '16px 20px',
        marginBottom: 20,
        '& ::placeholder':{
            color: '#999',
            fontSize: 14,
            opacity: 1,
        },
      },
      whiteQuestionCard:{
        display:'flex',
        background: '#FFF',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        borderRadius: 4,
        padding: '16px 20px',
        marginBottom: 20,
        '& ::placeholder':{
            color: '#999',
            fontSize: 14,
            opacity: 1,
        },
      },
      '& ::placeholder':{
        color: '#999',
        fontSize: 14,
        opacity: 1,
      },
      greyText:{
          color: '#999',
          fontSize: 14,
          opacity: 1,
      },
      mainHeading:{
        fontWeight: 600,
        fontSize: 20,
        color: '#333',
        marginBottom: 15,
      },
      whitecardContainer:{
        margin: '14px 0'
      },
      inputLabel:{
        fontSize: 16,
        color: '#333',
        marginBottom: 10,
      },
      customInput:{
          '&>:first-child':{
            width: '100%'
          },          
      },
      textField:{
        width: '100%',
        '&>:first-child':{    
            '&>:first-child':{
                '&>:first-child':{
                    border: '1px solid #dfdfdf',
                    borderRadius: 4,
                    padding: 10,
                }
            },
            '&::before':{
                display: 'none'
            }
        }
      },
      textField1:{
        width: '100%',
        '&>:first-child':{    
            '&>:first-child':{
                '&>:first-child':{
                    border: '1px solid #dfdfdf',
                    borderRadius: 4,
                    padding: '8px 10px',
                }
            },
            '&::before':{
                display: 'none'
            }
        }
      },
  });

